import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of, switchMap } from 'rxjs';
import { ParcelService } from '../_services';
import * as ParcelActions from '../_actions/parcel';

@Injectable({
  providedIn: 'root',
})
export class ParcelEffects {
  loadParcels$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ParcelActions.loadParcels),
      // switchMap cancels the previous request if a new loadParcels action comes in
      switchMap(({ year }) =>
        this.parcelService.getParcels(year).pipe(
          map((parcels) => ParcelActions.loadParcelsSuccess({ parcels })),
          catchError((error) => of(ParcelActions.loadParcelsFailure({ error })))
        )
      )
    )
  );

  addParcel$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ParcelActions.addParcel),
      mergeMap(({ parcel }) =>
        this.parcelService.saveParcel(parcel).pipe(
          map((savedParcel) => ParcelActions.addParcelSuccess({ parcel: savedParcel })),
          catchError((error) => of(ParcelActions.addParcelFailure({ error })))
        )
      )
    )
  );

  updateParcel$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ParcelActions.updateParcel),
      mergeMap(({ parcel }) =>
        this.parcelService.saveParcel(parcel).pipe(
          map((updatedParcel) => ParcelActions.updateParcelSuccess({ parcel: updatedParcel })),
          catchError((error) => of(ParcelActions.updateParcelFailure({ error })))
        )
      )
    )
  );

  deleteParcel$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ParcelActions.deleteParcel),
      mergeMap(({ id }) =>
        this.parcelService.deleteParcel(id).pipe(
          map(() => ParcelActions.deleteParcelSuccess({ id })),
          catchError((error) => of(ParcelActions.deleteParcelFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private parcelService: ParcelService
  ) {}
}
